var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _vm._v(_vm._s(_vm.$t("columnSelection"))),
      ]),
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { staticClass: "column-scroll" },
          _vm._l(_vm.headers, function (column) {
            return _c(
              "v-col",
              {
                key: "cb" + column,
                staticClass: "pa-0 ma-0",
                attrs: { "max-width": "10000" },
              },
              [
                _c("v-checkbox", {
                  attrs: {
                    dense: "",
                    "input-value": _vm.isChecked(column),
                    label: _vm.$t(column),
                    "hide-details": "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.updateChecked(column)
                    },
                  },
                }),
              ],
              1
            )
          }),
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }